import LazyLoad from 'vanilla-lazyload';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import '../components/video';

const initLazyLoad = new LazyLoad();
initLazyLoad.update();

const topicsSlider = document.querySelector('.subscription-metrics-topics');
if (topicsSlider) {
	const paginationEl = topicsSlider.querySelector(
		'.subscription-metrics-topics__pagination',
	);
	// eslint-disable-next-line no-new
	new Swiper(topicsSlider, {
		modules: [Pagination],
		slidesPerView: 1,
		spaceBetween: 16,
		loop: true,
		autoplay: {
			delay: 1000,
			disableOnInteraction: false,
		},
		pagination: {
			el: paginationEl,
			clickable: true,
			enabled: true,
		},
		breakpoints: {
			992: {
				slidesPerView: 'auto',
				spaceBetween: 0,
				allowTouchMove: false,
				loop: false,
				autoplay: false,
				pagination: {
					enabled: false,
				},
			},
		},
	});
}

/**
 * Newsroom Sticky Stacking Animation
 */
const initNewsroomStickyCards = () => {
	const section = document.querySelector('.newsroom-features');
	if (!section) return;

	const cards = section.querySelectorAll('.js-feature-card');
	const firstCard = cards[0];
	const divider = section.querySelector('.js-divider');
	const header = document.querySelector('.site-header');

	const updateOffsets = () => {
		const headerHeight = header ? header.offsetHeight : 0;
		const isDesktop = window.innerWidth >= 768;

		cards.forEach((card) => {
			card.style.height = 'auto';
		});

		if (!isDesktop) return;

		let firstCardHeaderHeight = 0;
		if (firstCard && divider) {
			const firstRect = firstCard.getBoundingClientRect();
			const dividerRect = divider.getBoundingClientRect();
			firstCardHeaderHeight = dividerRect.bottom - firstRect.top;
		}

		let maxContentHeight = 0;
		cards.forEach((card, index) => {
			let contentHeight = card.offsetHeight;
			if (index === 0 && firstCardHeaderHeight > 0) {
				contentHeight -= firstCardHeaderHeight;
			}
			if (contentHeight > maxContentHeight) {
				maxContentHeight = contentHeight;
			}
		});

		cards.forEach((card, index) => {
			if (index === 0 && firstCardHeaderHeight > 0) {
				card.style.height = `${firstCardHeaderHeight + maxContentHeight}px`;
			} else {
				card.style.height = `${maxContentHeight}px`;
			}
			card.style.zIndex = index + 1;
		});

		if (firstCard && divider) {
			section.style.setProperty('--header-h', `${headerHeight}px`);
			section.style.setProperty(
				'--divider-offset',
				`${firstCardHeaderHeight}px`,
			);
		}
	};

	const handleScroll = () => {
		const isDesktop = window.innerWidth >= 768;
		if (!cards[1] || !divider || !isDesktop) {
			if (divider) divider.classList.remove('is-hidden');
			return;
		}

		const secondCard = cards[1];
		const rect = secondCard.getBoundingClientRect();
		const stickyTop = parseFloat(window.getComputedStyle(secondCard).top);

		if (rect.top <= stickyTop + 2) {
			divider.classList.add('is-hidden');
		} else {
			divider.classList.remove('is-hidden');
		}
	};

	updateOffsets();
	handleScroll();
	window.addEventListener('resize', updateOffsets);
	window.addEventListener('scroll', handleScroll);
};

initNewsroomStickyCards();
